module.exports = __webpack_public_path__ + "img/firm21.043f9fbf.png";